var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _clipPath, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgKurzMalWegDe = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  clipRule: "evenodd",
  viewBox: "0 0 532.44 72.27"
}, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
  id: "kurz-mal-weg-de_svg__a"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#80ba27"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4c9b34"
}))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#kurz-mal-weg-de_svg__a",
  id: "kurz-mal-weg-de_svg__c",
  x1: 476.02,
  x2: 476.02,
  y1: 0,
  y2: 56.41,
  gradientTransform: "rotate(.181 -8000 0)",
  gradientUnits: "userSpaceOnUse"
})), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#kurz-mal-weg-de_svg__a",
  id: "kurz-mal-weg-de_svg__d",
  x1: 447.66,
  x2: 447.66,
  y1: 44.21,
  y2: 56.33,
  gradientTransform: "rotate(.181 -8000 0)",
  gradientUnits: "userSpaceOnUse"
})), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#kurz-mal-weg-de_svg__a",
  id: "kurz-mal-weg-de_svg__e",
  x1: 417.75,
  x2: 417.75,
  y1: 14.89,
  y2: 72.26,
  gradientTransform: "rotate(.181 -8000 431.6)",
  gradientUnits: "userSpaceOnUse"
})), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#kurz-mal-weg-de_svg__a",
  id: "kurz-mal-weg-de_svg__f",
  x1: 379.6,
  x2: 379.6,
  y1: 14.73,
  y2: 56.57,
  gradientTransform: "rotate(.181 -8000 0)",
  gradientUnits: "userSpaceOnUse"
})), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#kurz-mal-weg-de_svg__a",
  id: "kurz-mal-weg-de_svg__g",
  x1: 333.68,
  x2: 333.68,
  y1: 15.84,
  y2: 55.86,
  gradientTransform: "rotate(.181 -8000 0)",
  gradientUnits: "userSpaceOnUse"
})), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#kurz-mal-weg-de_svg__a",
  id: "kurz-mal-weg-de_svg__h",
  x1: 292.8,
  x2: 292.8,
  y1: 28.12,
  y2: 37.24,
  gradientTransform: "rotate(.181 -8000 0)",
  gradientUnits: "userSpaceOnUse"
})), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#kurz-mal-weg-de_svg__a",
  id: "kurz-mal-weg-de_svg__i",
  x1: 271.37,
  x2: 271.37,
  y1: 0,
  y2: 56.57,
  gradientTransform: "rotate(.181 -8000 0)",
  gradientUnits: "userSpaceOnUse"
})), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#kurz-mal-weg-de_svg__a",
  id: "kurz-mal-weg-de_svg__j",
  x1: 238.88,
  x2: 238.88,
  y1: 15.05,
  y2: 56.09,
  gradientTransform: "rotate(.181 -8000 0)",
  gradientUnits: "userSpaceOnUse"
})), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#kurz-mal-weg-de_svg__a",
  id: "kurz-mal-weg-de_svg__k",
  x1: 190.32,
  x2: 190.32,
  y1: 14.73,
  y2: 55.46,
  gradientTransform: "rotate(.181 -8000 0)",
  gradientUnits: "userSpaceOnUse"
})), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#kurz-mal-weg-de_svg__a",
  id: "kurz-mal-weg-de_svg__l",
  x1: 145.83,
  x2: 145.83,
  y1: 28.12,
  y2: 37.24,
  gradientTransform: "rotate(.181 -8000 0)",
  gradientUnits: "userSpaceOnUse"
})), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#kurz-mal-weg-de_svg__a",
  id: "kurz-mal-weg-de_svg__m",
  x1: 118.45,
  x2: 118.45,
  y1: 15.84,
  y2: 55.46,
  gradientTransform: "rotate(.181 -8000 0)",
  gradientUnits: "userSpaceOnUse"
})), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#kurz-mal-weg-de_svg__a",
  id: "kurz-mal-weg-de_svg__n",
  x1: 89.18,
  x2: 89.18,
  y1: 14.97,
  y2: 55.46,
  gradientTransform: "rotate(.181 -8000 0)",
  gradientUnits: "userSpaceOnUse"
})), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#kurz-mal-weg-de_svg__a",
  id: "kurz-mal-weg-de_svg__o",
  x1: 54.16,
  x2: 54.16,
  y1: 15.84,
  y2: 56.57,
  gradientTransform: "rotate(.181 -8000 0)",
  gradientUnits: "userSpaceOnUse"
})), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#kurz-mal-weg-de_svg__a",
  id: "kurz-mal-weg-de_svg__p",
  x1: 17.27,
  x2: 17.27,
  y1: 0,
  y2: 55.46,
  gradientTransform: "rotate(.181 -8000 0)",
  gradientUnits: "userSpaceOnUse"
})), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#kurz-mal-weg-de_svg__a",
  id: "kurz-mal-weg-de_svg__r",
  x1: 516.19,
  x2: 516.19,
  y1: 14.89,
  y2: 56.41,
  gradientTransform: "rotate(.181 -8000 0)",
  gradientUnits: "userSpaceOnUse"
})), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
  id: "kurz-mal-weg-de_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h532.44v72.27H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  clipPath: "url(#kurz-mal-weg-de_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#kurz-mal-weg-de_svg__c)",
  d: "M491.907 41.83c0 2.7 0 5.14.08 7.33.049 2.17.287 4.331.71 6.46h-4.28l-1.58-5.63h-.32a12.84 12.84 0 0 1-4.599 4.6 13.4 13.4 0 0 1-7.05 1.82q-7.92 0-11.77-5c-3.85-5-3.847-8.537-3.84-15.61q0-10.14 4.8-15.41c4.8-5.27 7.597-5.27 13.19-5.27 1.55-.029 3.099.078 4.63.32a23 23 0 0 1 3.689 1V0h6.34zm-15.999 9a9.35 9.35 0 0 0 6.42-2.1 11.2 11.2 0 0 0 3.239-6.37V22.74a9 9 0 0 0-3.249-1.59 20.2 20.2 0 0 0-4.83-.47 10.67 10.67 0 0 0-8.56 3.6q-3.09 3.62-3.09 11.53c-.012 2.011.159 4.02.51 6a14.5 14.5 0 0 0 1.71 4.76 8.85 8.85 0 0 0 3.13 3.13 9.13 9.13 0 0 0 4.71 1.16z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#kurz-mal-weg-de_svg__d)",
  d: "M441.198 50.23a5.74 5.74 0 0 1 1.74-4.4 6.5 6.5 0 0 1 4.6-1.62 6.7 6.7 0 0 1 4.75 1.62 5.75 5.75 0 0 1 1.75 4.4 5.87 5.87 0 0 1-1.75 4.44 6.6 6.6 0 0 1-4.75 1.66 6.38 6.38 0 0 1-4.6-1.66 5.86 5.86 0 0 1-1.74-4.44"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#kurz-mal-weg-de_svg__e)",
  d: "M435.418 55.462q0 8.64-4.68 12.72c-4.68 4.08-7.477 4.08-13.07 4.08a40 40 0 0 1-9-.8 22.3 22.3 0 0 1-5-1.66l2.14-8.16c1.22.48 2.63 1 4.24 1.43a21.7 21.7 0 0 0 6 .71c3.59 0 6-.78 7.33-2.34a9.92 9.92 0 0 0 1.94-6.53v-2.55h-.25q-2.78 3.72-9.83 3.72-7.68 0-11.45-4.75c-3.77-4.75-3.767-8.133-3.76-14.9q0-10.61 5.07-16.08c5.07-5.47 8.293-5.47 14.74-5.47a51.5 51.5 0 0 1 9.07.72c2.225.36 4.413.915 6.54 1.66zm-17.44-7.61a7.07 7.07 0 0 0 4.64-1.34 8.6 8.6 0 0 0 2.5-4v-17.87a15.8 15.8 0 0 0-6.11-1 7.28 7.28 0 0 0-6.18 3q-2.21 3-2.21 9.47c0 3.85.63 6.79 1.9 8.79a6.07 6.07 0 0 0 5.46 2.95"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#kurz-mal-weg-de_svg__f)",
  d: "M395.718 52.05a20 20 0 0 1-6.46 3.21 28.3 28.3 0 0 1-8.67 1.31q-9.59 0-14-5.59c-4.41-5.59-4.417-8.837-4.43-15.33q0-10.46 5-15.69c5-5.23 8-5.23 14-5.23a21.8 21.8 0 0 1 5.87.8 13.75 13.75 0 0 1 5.07 2.61 13 13 0 0 1 3.56 4.91 19.3 19.3 0 0 1 1.35 7.69 35 35 0 0 1-.2 3.56 50 50 0 0 1-.59 4h-23.79c.16 3.32 1 5.83 2.57 7.52s4.07 2.54 7.57 2.54a16.2 16.2 0 0 0 5.82-1 16 16 0 0 0 3.92-2zm-14.74-29.08q-4 0-6 2.42a12 12 0 0 0-2.34 6.46h14.74c.21-2.85-.22-5-1.31-6.58a5.82 5.82 0 0 0-5.09-2.3"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#kurz-mal-weg-de_svg__g)",
  d: "m338.278 15.84 7.21 20.29 1.42 6.57h.32l1.11-6.65 5.07-20.21h9.43l-12.2 40h-7.57l-8-22.19-1-5h-.4l-.95 5.07-7.65 22.14h-7.85l-12.76-40h11.18l5.78 19.89.95 7h.4l1.34-7.13 6.58-19.81z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#kurz-mal-weg-de_svg__h)",
  d: "M282.819 28.12h19.879v9.12h-19.879z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#kurz-mal-weg-de_svg__i)",
  d: "M272.359 42.15a8.7 8.7 0 0 0 .71 4 2.45 2.45 0 0 0 2.3 1.27q.938.003 1.86-.16a11.5 11.5 0 0 0 2.26-.71l1.11 8.08a19.7 19.7 0 0 1-3.89 1.26 22.3 22.3 0 0 1-5.38.64q-4.51 0-6.9-2.1c-2.39-2.1-2.38-3.697-2.36-6.89V0h10.3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#kurz-mal-weg-de_svg__j)",
  d: "M224.189 18.14a34.2 34.2 0 0 1 7.52-2.26 49 49 0 0 1 9.11-.83 20.7 20.7 0 0 1 6.9 1 9.89 9.89 0 0 1 6.69 7.17c.473 1.866.701 3.785.68 5.71q0 3.48-.24 7c-.24 3.52-.253 4.657-.28 6.93q0 3.41.2 6.62a24.7 24.7 0 0 0 1.19 6.06h-8.4l-1.66-5.47h-.4a14.1 14.1 0 0 1-4.43 4.29 13.3 13.3 0 0 1-7.25 1.78 14 14 0 0 1-5-.83 10.72 10.72 0 0 1-6.26-6 12.2 12.2 0 0 1-.87-4.71 11 11 0 0 1 1.62-6.14 11.74 11.74 0 0 1 4.76-4.1 23 23 0 0 1 7.29-2.13 51 51 0 0 1 9.47-.36c.36-3 .15-5.08-.64-6.38s-2.56-1.94-5.31-1.94a36.3 36.3 0 0 0-6.53.63 24 24 0 0 0-5.67 1.67zm13.07 29.48a7.93 7.93 0 0 0 4.91-1.39 9.7 9.7 0 0 0 2.7-3v-5.15a28 28 0 0 0-4.72-.08c-1.356.08-2.699.318-4 .71a6.66 6.66 0 0 0-2.77 1.59 3.5 3.5 0 0 0-1 2.61 4.5 4.5 0 0 0 1.3 3.45 5.08 5.08 0 0 0 3.58 1.26"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#kurz-mal-weg-de_svg__k)",
  d: "M185.129 55.46V33.91c0-3.65-.35-6.23-1-7.77s-2.12-2.29-4.28-2.29a6.38 6.38 0 0 0-4.36 1.46 9.3 9.3 0 0 0-2.54 3.77v26.38h-10.3V15.84h8l1.18 5.23h.32a18 18 0 0 1 4.64-4.43 12.66 12.66 0 0 1 7.25-1.91 11.4 11.4 0 0 1 6.22 1.55 10 10 0 0 1 3.76 5.19 14.3 14.3 0 0 1 4.67-4.91 12.53 12.53 0 0 1 6.9-1.83 17.7 17.7 0 0 1 5.66.8 7.84 7.84 0 0 1 3.82 2.73 13.3 13.3 0 0 1 2.17 5.19c.531 2.714.772 5.476.72 8.24v23.77h-10.3V33.2c.109-2.375-.23-4.75-1-7q-1-2.32-4.4-2.33a6.23 6.23 0 0 0-4.4 1.5 9 9 0 0 0-2.41 4.12v26z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#kurz-mal-weg-de_svg__l)",
  d: "M135.839 28.12h19.89v9.12h-19.89z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#kurz-mal-weg-de_svg__m)",
  d: "m102.879 46.74 15.61-18.77 4-3.41h-19.61v-8.72h31.06v8.72l-15.45 19.09-4 3.09h19.41v8.72h-31.02z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#kurz-mal-weg-de_svg__n)",
  d: "M99.4 25.51a13.5 13.5 0 0 0-4.44-.87 7.28 7.28 0 0 0-4.63 1.46 7 7 0 0 0-2.5 3.77v25.59h-10.3V15.84h8l1.19 5.23h.35a10.7 10.7 0 0 1 3.64-4.51 9.24 9.24 0 0 1 5.39-1.59c1.593.04 3.169.334 4.669.87z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#kurz-mal-weg-de_svg__o)",
  d: "M46.79 15.84v22.52q0 4.83 1.15 7c.76 1.42 2.25 2.14 4.47 2.14a7 7 0 0 0 4.88-1.75 10.76 10.76 0 0 0 2.89-4.27v-25.6h10.3v27.58a61 61 0 0 0 .32 6.37 39 39 0 0 0 1 5.67h-7.77l-1.82-5.86h-.32a14.8 14.8 0 0 1-5.07 5 14.5 14.5 0 0 1-7.68 2 17.2 17.2 0 0 1-5.39-.79 8.77 8.77 0 0 1-4-2.62 12.1 12.1 0 0 1-2.42-4.91 30.7 30.7 0 0 1-.83-7.76V15.84z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#kurz-mal-weg-de_svg__p)",
  d: "M13.07 39.06H10.3v16.4H0V0h10.3v32.72l2.38-1.11 9-15.77h11.33L23.5 30.9l-4 3 4.36 3.09 10.7 18.46H22.7z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#kurz-mal-weg-de_svg__r)",
  d: "M531.067 52.29a17.9 17.9 0 0 1-6 3 25.8 25.8 0 0 1-7.64 1.11 19.3 19.3 0 0 1-7.85-1.47 13.9 13.9 0 0 1-5.46-4.19 18.1 18.1 0 0 1-3.17-6.54 32.7 32.7 0 0 1-1-8.56q0-10.14 4.51-15.45c4.51-5.31 7.313-5.31 12.92-5.31 1.813.002 3.621.204 5.39.6a11.41 11.41 0 0 1 8.32 7 20.3 20.3 0 0 1 1.34 8 40 40 0 0 1-.47 5.79h-25.48c-.029 2.083.214 4.16.72 6.18a12 12 0 0 0 2.21 4.55 9.7 9.7 0 0 0 3.93 2.85 15.6 15.6 0 0 0 5.9 1 16 16 0 0 0 5.39-.95 11.55 11.55 0 0 0 4-2.21zm-13.63-31.85a11 11 0 0 0-7.49 2.46q-2.82 2.44-3.37 8.39h19.65c0-4-.76-6.82-2.3-8.43a8.52 8.52 0 0 0-6.51-2.42z"
}))));
export default SvgKurzMalWegDe;